/**
 * @generated SignedSource<<5cbf2bb3197664d32bcec5955a17b133>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserCard_GuildMembershipBadgesFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly guild: {
        readonly primaryPhoto: {
          readonly " $fragmentSpreads": FragmentRefs<"GraphQLImage_image">;
        } | null | undefined;
        readonly slugId: string;
        readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhoto_guild">;
      } | null | undefined;
      readonly id: string;
      readonly membershipLevel: GuildMembershipLevel;
    } | null | undefined;
  }>;
  readonly " $fragmentType": "UserCard_GuildMembershipBadgesFragment";
};
export type UserCard_GuildMembershipBadgesFragment$key = {
  readonly " $data"?: UserCard_GuildMembershipBadgesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCard_GuildMembershipBadgesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCard_GuildMembershipBadgesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GuildMembershipsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildMembership",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "membershipLevel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Guild",
              "kind": "LinkedField",
              "name": "guild",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slugId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Image",
                  "kind": "LinkedField",
                  "name": "primaryPhoto",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "GraphQLImage_image"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GuildPrimaryPhoto_guild"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuildMembershipsConnection",
  "abstractKey": null
};

(node as any).hash = "275073115733f30d339715be0934b9a1";

export default node;
